import React, {useEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { generateOtp, SIGN_UP_STATE } from "../../Actions/signupAction";
import LoadingSpinner from "../CommonComponents/loadingSpinner";
import CountryList from "../SignUp/countryList";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'



const BasicInfoV2 = ({setFormdata, formdata, handleNext, handleBack}) => {
    const otpInfo = useSelector(state => state.otp);
    const signupState = useSelector(state => state.signingUpState);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const emailRef = useRef(null);
    
    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);
    const nextRef = useRef(null);

    const [country, setCountry] = useState(formdata?.country ?? 'US');
    const [phone, setPhone] = useState(formdata?.phoneNumber);

    const handlePhoneChange = (value) => {
        setPhone(value);
    };

    const [error, setError] = useState(null);

    useEffect(() => {
        if (error) {
            let timer = setTimeout(() => setError(null), 10 * 1000);
            return () => clearTimeout(timer);
        }
    }, [error])

    useEffect(() => {
        firstNameRef.current.value = formdata?.firstName ?? '';
        lastNameRef.current.value = formdata?.lastName ?? '';
        emailRef.current.value = formdata?.email ?? '';
        passwordRef.current.value = formdata?.password ?? '';
        confirmPasswordRef.current.value = formdata?.password ?? '';
    }, [formdata]);

    useEffect(() => {
        if (loading && otpInfo.generated !== null) {
            handleNext();
            return;
        }

        if(loading && otpInfo.genError) {
            setError("Cannot initiate phone number verification, please try later");
            setLoading(false);
            return;
        }

        if (otpInfo.verifError) {
            setError("Wrong OTP provided or OTP expired");
            setLoading(false);
            return;
        }
    }, [otpInfo, loading]);

    useEffect(() => {
        if (signupState === false) {
            setTimeout(() => {
                dispatch({type: SIGN_UP_STATE,payload: null});
            }, 10000);
            setError("Partner with email or phone number already exists");
        }
    }, [signupState]);
    

    const handleSubmit = (ev) => {
        ev.preventDefault();

        setFormdata({
            ...formdata,
            firstName: firstNameRef.current.value,
            lastName: lastNameRef.current.value,
            email: emailRef.current.value,
            country: country,
            phoneNumber: phone,
            password: passwordRef.current.value,
        })

        setLoading(true);
        dispatch(generateOtp(phone));
    }

    const handlePassMatch = () => {
        if (confirmPasswordRef.current.value !== "" && passwordRef.current.value !== confirmPasswordRef.current.value) {
            nextRef.current.disabled = true;
            confirmPasswordRef.current.style.border = "1px solid red";
        } else if (confirmPasswordRef.current.value === "") {
            confirmPasswordRef.current.style.border = "";
        } else {
            nextRef.current.disabled = false;
            confirmPasswordRef.current.style.border = "";
        }

    }

    return (
        <form className="d-flex flex-column sd-form" onSubmit={handleSubmit}>
            <div className="login-title">Tell us about you</div>
            <div className="d-flex flex-column">
                <label className="sd-label">First name</label>
                <input ref={firstNameRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Last name</label>
                <input ref={lastNameRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Email</label>
                <input ref={emailRef} type="email" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Country (Available in selected countries)</label>
                <select className="sd-input form-select" required={true} value={country} onChange={e => setCountry(e.target.value)}>
                    <CountryList/>
                </select>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Phone Number</label>
                <PhoneInput
                    country={country.toLowerCase()}
                    value={phone}
                    onChange={handlePhoneChange}
                    disableDropdown 
                    disableCountryCode={false} 
                    specialLabel=""
                    inputProps={{
                        required: true
                    }}
                    containerClass="sd-input--phone-container" 
                    inputClass="sd-input--phone-input"
                    placeholder=""
                    countryCodeEditable={false}
                    inputStyle={{
                        width: "100%",
                        lineHeight: "1.8",
                        fontSize: "15px",
                        marginTop: "4px",
                        padding: "6px 16px 6px 50px",
                        border: "1px solid #D3D3D3",
                        borderRadius: "4px",
                        color: "#242424",
                    }}
                    buttonStyle={{
                        background: "transparent",
                      }}
                />
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Password</label>
                <input ref={passwordRef} type="password" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Confirm password</label>
                <input ref={confirmPasswordRef} type="password" required={true} className="sd-input" onChange={handlePassMatch}/>
            </div>
            { 
                error && <div className="alert alert-danger fw-bold">
                    {error}
                </div>
            }
            <div className="d-flex justify-content-center text-center gap-8">
                <div className="login-btn login-secondary-btn w-100" onClick={handleBack}>Back</div>
                <input ref={nextRef} type="submit" className="login-btn login-primary-btn w-100" value="Continue"></input>
            </div>
            {loading && <LoadingSpinner target={"sd-form"} />}
        </form>
    )
}

export default BasicInfoV2;
